






import ViewModel from '@/views/service/AdminDetail.ts';
export default ViewModel;
